module.exports = __webpack_public_path__ + "static/img/郭振宇董事长2.53811b40.png";